const browserOrigin =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : 'http://localhost:3000';

export const appEnv = {
  siteUrl: (import.meta.env.VITE_SITE_URL?.trim() || browserOrigin).replace(/\/$/, ''),
  appName: import.meta.env.VITE_APP_NAME?.trim() || 'Stingray',
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL?.trim() || '/api').replace(/\/$/, ''),
};

export function getAbsoluteSiteUrl(path = '') {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${appEnv.siteUrl}${path ? normalizedPath : ''}`;
}
